import React, { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';

// import { API } from "../../../api/SampleResponse";
import API from "../../../api";
import { Button, RenderFormFieldsHOC } from "../../../components";
import { SkeletonFormView } from "../../../components";

export const NewCampaign = () => {
    const [campaignUIConfigLoading, setCampaignUIConfigLoading] = useState(false);
    const [selectedCatalogId, setSelectedCatalogId] = useState(null)
    const [formSubmitClick, setFormSubmitClick] = useState(false);
    const [isFormError, setIsFormError] = useState(false)
    const [campaignUIConfig, setCampaignUIConfig] = useState(null);
    const [campaignBaseLoading, setCampaignBaseLoading] = useState(false);
    const [campaignBaseUIConfig, setCampaignBaseUIConfig] = useState(null);
    const [saveDraftLoading, setSaveDraftLoading] = useState(false);
    const configRef = useRef(null)
    const baseConfigRef = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (campaignUIConfig) {
            configRef.current = campaignUIConfig //in this way whenever I am changing the state I can manual trigger config to update and anyways render function call is happening
            setCampaignUIConfigLoading(false)
        }
    }, [campaignUIConfig])

    useEffect(() => {
        if (campaignBaseUIConfig) {
            baseConfigRef.current = campaignBaseUIConfig
            setCampaignBaseLoading(false)
        }
    }, [campaignBaseUIConfig])

    useEffect(() => {
        campaignUIBaseConfig({ catalogId: "CAMPAIGN_BASE" })
    }, [])


    useEffect(() => {
        //Handle Form submit to api call, currently only for Drafts
        if (!isFormError && formSubmitClick) {
            //show TOAST to confirm, to handle the form error case
            // Ensure we're using the latest configRef which includes all updates (including payment restrictions)
            const catalogComponentToSave = configRef.current || campaignUIConfig
            console.log("Saving catalogComponent:", catalogComponentToSave)
            saveCampaignToDrafts({
                catalogComponent: catalogComponentToSave
            })
        }
    }, [formSubmitClick, isFormError])

    // Helper function to extract the actual component structure from API responses
    // This ensures we always get the component itself, not wrapped in catalogComponent
    const extractComponent = (response) => {
        if (!response) return null
        
        // If response has catalogComponent, extract it recursively until we get the actual component
        let component = response
        while (component?.catalogComponent) {
            component = component.catalogComponent
        }
        
        // Return the component (should have componentType, keyName, children, etc., but NOT catalogComponent)
        return component
    }

    const getCampaignUIConfig = async ({ catalogId, catalogType }) => {
        try {
            setCampaignUIConfigLoading(true)
            const config = await API.getUIConfigV2({ catalogId, catalogType })
            
            // Extract the actual catalogComponent structure (unwrapping any nested catalogComponent)
            const catalogComponent = extractComponent(config)
            
            // Check if there's a child with keyName = 'payment_restrictions' in the children array
            if (catalogComponent?.children && Array.isArray(catalogComponent.children)) {
                const paymentRestrictionsIndex = catalogComponent.children.findIndex(
                    child => child?.keyName === 'payment_restrictions_section'
                )
                
                if (paymentRestrictionsIndex !== -1) {
                    // Call getPaymentCatalog to get the payment restrictions section
                    const paymentCatalog = await API.getPaymentCatalog()
                    
                    // Extract the payment section - unwrap any catalogComponent wrapper
                    const paymentSection = extractComponent(paymentCatalog)
                    
                    // Replace the placeholder payment_restrictions with the actual section
                    if (paymentSection) {
                        catalogComponent.children[paymentRestrictionsIndex] = paymentSection
                    }
                }
            }
            
            // Set campaignUIConfig to the extracted component (guaranteed to have no nested catalogComponent)
            setCampaignUIConfig(catalogComponent)
        } catch (err) {
            console.log(err)
            setCampaignUIConfigLoading(false)
        }
    }

    const campaignUIBaseConfig = async ({ catalogId }) => {
        try {
            setCampaignBaseLoading(true)
            const config = await API.getUIConfig({ catalogId })
            // setCampaignBaseLoading(false)
            setCampaignBaseUIConfig(config)

        } catch (err) {
            console.log(err)
            setCampaignBaseLoading(false)
        }
    }

    const errorCallback = (error) => {
        // syncing isFormError and error states 
        if (isFormError !== error) {
            setIsFormError(error);
        }
    }

    const behaviorConfigCallback = ({ updatedValue, behaviourConfig }) => {
        if (behaviourConfig) {
            const { valueConfig: { selectedValues } } = updatedValue
            const { onSelectChange } = behaviourConfig
            //search for the catalogId in the behaviorConfig that matches with id of selectedValue
            const selectedBehaviorConfig = onSelectChange.find(({ id }) => id === selectedValues[0])
            console.log("selectedBehaviorConfig: ", selectedBehaviorConfig)
            getCampaignUIConfig({
                catalogId: selectedBehaviorConfig?.catalogId,
                catalogType: "CAMPAIGN"
            })
            setSelectedCatalogId(selectedBehaviorConfig?.catalogId)
        }
    }

    const saveCampaignToDrafts = async ({ catalogComponent }) => {
        try {
            setSaveDraftLoading(true)
            
            // Ensure we're using the actual component structure (unwrap if needed)
            const componentToSave = extractComponent(catalogComponent)
            
            const response = await API.createConfigV2({
                catalogState: "DRAFT",
                catalogComponent: componentToSave,
                catalogType: "CAMPAIGN"
            })

            setSaveDraftLoading(false)

            const { catalogInstanceDetails: { catalogInstanceId, status } } = response || {}
            setFormSubmitClick(false)
            if (status === "SUCCESS") {
                toast.success('Campaign saved successfully', {
                    position: "bottom-right"
                })
                navigate(`/campaigns/campaign/attach-rules/campaign/${catalogInstanceId}?type=${catalogComponent?.catalogId?.slice('CAMPAIGN_'.length)}`, {
                    replace: true
                })
            }
        } catch (err) {
            setSaveDraftLoading(false)
            setFormSubmitClick(false)
            toast.error('Unable to save Campaign.', {
                position: "bottom-right"
            })
        }
    }

    return (
        <div className="w-full h-full overflow-auto px-8 py-3">
            <p className="text-xl font-medium sticky -top-3 z-10 p-3 bg-white">Create Campaign</p>
            {/* Field for storing Camapign type */}

            <div className="flex flex-col gap-6 pt-4 px-2">

                {
                    campaignBaseLoading && <div className="skeleton w-72 h-14 rounded-md bg-accent"></div>
                }
                {/* Below is hard coded for Showing only one Dropdown with behaviorConfig, 
                    which is used to make api calls and do some specific state updates 

                */}
                {
                    !campaignBaseLoading && campaignBaseUIConfig && baseConfigRef.current &&
                    <>
                        <RenderFormFieldsHOC
                            config={baseConfigRef.current}
                            parent={baseConfigRef.current}
                            childIndex={0}
                            sectionId={""} //initially the Json has a PAGE as parent
                            formSubmitClick={formSubmitClick}
                            errorCallback={errorCallback}
                            rerenderFormUI={setCampaignUIConfig}
                            viewMode={false}
                            behaviorConfigCallback={behaviorConfigCallback}
                        />
                    </>
                }


                {campaignUIConfigLoading && <SkeletonFormView />}


                {!campaignUIConfigLoading && campaignUIConfig &&
                    <>
                        <RenderFormFieldsHOC
                            config={configRef.current}
                            parent={configRef.current}
                            childIndex={0}
                            sectionId={""}
                            formSubmitClick={formSubmitClick}
                            errorCallback={errorCallback}
                            rerenderFormUI={setCampaignUIConfig}
                            viewMode={false}
                        />
                    </>
                }
            </div>


            {/* Attach Rules UI:  */}

            {/* Show only when the catalog type is selected */}
            {
                /**
                 * Trigger validation of form fields first
                 * On validate of fields only trigger api call  to save as draft, and then redirect user to attach rules below
                 * 
                 */
            }

            <div className="flex justify-end items-center gap-2 mt-2">
                <Button
                    variant="primary"
                    onClick={() => {
                        setFormSubmitClick(true)
                        toast('Please wait till the campaign is saved', {
                            position: "bottom-right"
                        })
                    }}>
                    Attach Rules
                </Button>
                <Button
                    variant="primary"
                    disabled={saveDraftLoading}
                    onClick={() => {
                        setFormSubmitClick(true)
                        //post api call or any error revert back to false
                    }
                    }
                >
                    Save to Drafts
                </Button>
            </div>
        </div >
    )
}
